import { render, staticRenderFns } from "./ReservationWidgetsList.vue?vue&type=template&id=23aaefe0&scoped=true"
import script from "./ReservationWidgetsList.vue?vue&type=script&lang=js"
export * from "./ReservationWidgetsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aaefe0",
  null
  
)

export default component.exports